export default {
  OPHTHALMITIS: 'ophthalmitis', // ตาอักเสบ
  CORNEAL_OPACITY: 'corneal opacity', // กระจกตาขุ่น
  ULCERATE: 'ulcerate', // แผลหลุม
  OCULAR_HYPERTENSION: 'ocular hypertension' // ความดันตา
}
